// extracted by mini-css-extract-plugin
module.exports = {"container":"fixtureData__container___3J04-","icon":"fixtureData__icon___2SR2j","text":"fixtureData__text___1JMWR"};